import { useState } from 'react'

export function useExportTemplateModal() {
    const [selectedStack, setSelectedStack] = useState<StackDto | null>(null)

    // Use timeout to register inner click events before saving the value.
    const open = (stack: StackDto) => setTimeout(() => setSelectedStack(stack), 250)
    const close = () => setSelectedStack(null)

    const isOpen = !!selectedStack

    return { isOpen, open, close, exportStack: selectedStack }
}
